import script from "./RolesResponsibilitiesFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./RolesResponsibilitiesFormView.vue?vue&type=script&setup=true&lang=js"

import "./RolesResponsibilitiesFormView.vue?vue&type=style&index=0&id=7d606af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d606af8"]])

export default __exports__